import React, { Component } from 'react';
import Datetime from 'react-datetime'
import '../../../../../node_modules/react-datetime/css/react-datetime.css'
import { BeatLoader } from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import moment from 'moment';
import Toggle from 'react-toggle';
import { get } from '../../../../server/actions'
import { _addNotification, _addNotificationError, formatDate, showFile, getModuleEnum, getAccessLevelByModule } from "../../../../server/util";
import { date_format } from '../../../../server/constants';
import { cepDailyEditCheckReport, cepReimbursementClime } from './cepServices';
let download = require('downloadjs');
const enumMealType = {
    lunch: 'Lunch',
    breakfast: 'Breakfast',
    snack: 'Snack',
    milk: 'Milk'
}
const modEnum = getModuleEnum();
class CepAuditReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            startDate: moment().startOf('month'),
            endDate: moment(),
            rptMonth: moment(),
            claimMonth: moment(),
            isLunch: true,
            mealType: (getAccessLevelByModule(modEnum.LMCU) || getAccessLevelByModule(modEnum.LMCI) ? enumMealType.lunch :
                (getAccessLevelByModule(modEnum.BMCU) || getAccessLevelByModule(modEnum.BMCI)) ? enumMealType.breakfast :
                    (getAccessLevelByModule(modEnum.SMCU) || getAccessLevelByModule(modEnum.SMCI)) ? enumMealType.snack :
                        null),
            rptType: 0,
            loading: false,
        }
        this.renderInput = this.renderInput.bind(this);
        this.downloadReport = this.downloadReport.bind(this);
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    downloadReport = () => {
        let _refNotify = this.props.refNotify;
        let _self = this;

        if (this.state.rptType === 0) {
            this.setState({ loading: true });

            cepReimbursementClime({
                start: moment(this.state.startDate).format('YYYY-MM-DDT00:00:00'),
                end: moment(this.state.endDate).format('YYYY-MM-DDT23:59:59'),
                schoolId: sessionStorage.getItem('SchoolId'),
                schoolYear: sessionStorage.getItem('schoolYearValue'),
                mealType: this.state.mealType,
                yearMonth: moment(this.state.claimMonth).format('YYYYMM')
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 417 || response.status === 422 || response.status === 400) {
                            return response.json();
                        }
                        //throw Error(response.errorMessage);
                    }
                    console.log('response', response);
                    return response;
                }).then(res => {
                    if (res.statusCode === 417) {
                        // _addNotificationError(res.statusMessage,this)
                        throw Error(res.statusMessage);
                    } else if (res.statusCode === 422) {
                        throw Error(res.statusMessage);
                    } else if (res.statusCode === 400) {
                        throw Error(res.statusMessage);

                    } else {
                        return res.blob();
                    }
                }).then(blob => {
                    let filename = "Summarized reimbursement claim report";
                    showFile(blob, filename);
                    this.setState({ loading: false })
                }).catch(
                    (error) => {
                        let msg = ''
                        if (typeof error === 'string') {
                            msg = error;
                        } else {
                            msg = error.message;
                        }
                        _addNotificationError(msg, _self)
                        //console.log('Get Excel File response', error)
                        this.setState({ loading: false })
                    }
                )
        } else {
            this.setState({ loading: true })
            const start = moment(this.state.rptMonth.startOf('month')).format('YYYY-MM-DDT00:00:00');
            const end = moment(this.state.rptMonth.endOf("month")).format('YYYY-MM-DDT23:59:59');

            cepDailyEditCheckReport({
                start: moment(start).format('YYYY-MM-DDT00:00:00'),
                end: moment(end).format('YYYY-MM-DDT23:59:59'),
                schoolId: sessionStorage.getItem('SchoolId'),
                schoolYear: sessionStorage.getItem('schoolYearValue'),
                mealType: this.state.mealType,
                yearMonth: this.state.rptMonth.format('YYYYMM')
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 417 || response.status === 422 || response.status === 400 || response.status === 500) {
                            return response.json();
                        }
                        //throw Error(response.errorMessage);
                    }
                    console.log('response', response);
                    return response;
                }).then(res => {
                    if (res.statusCode === 417) {
                        //_addNotificationError(res.errorMessage,this)
                        throw Error(res.errorMessage);
                    } else if (res.statusCode === 422 || res.statusCode === 400 || res.statusCode === 500) {
                        throw Error(res.statusMessage);
                    } else {
                        return res.blob();
                    }
                }).then(blob => {
                    let filename = "DailyEditCheckReport";
                    showFile(blob, filename);
                    this.setState({ loading: false })
                }).catch(
                    (error) => {
                        let msg = ''
                        if (typeof error === 'string') {
                            msg = error;
                        } else {
                            msg = error.message;
                        }
                        _addNotificationError(msg, _self)
                        //console.log('Get Excel File response', error)
                        this.setState({ loading: false })
                    }
                )


        }
    }
    render() {
        return (
            <div className="row">
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="col-md-offset-3 col-md-6">
                    <div className="panel panel-primary">
                        <div className="panel-body">
                            <div className="row">
                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                    <label className="custom-label col-md-4 text-left" style={{ margin: '18px 0px' }}>Report for</label>
                                    <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                        <div className="row">
                                            {
                                                (getAccessLevelByModule(modEnum.LMCU) || getAccessLevelByModule(modEnum.LMCI)) ?
                                                    <div className="styled-input-single col-md-4">
                                                        <input type="radio" name="mealType" id={'ceprb' + enumMealType.lunch} onChange={() => {
                                                            this.setState({ mealType: enumMealType.lunch })
                                                        }} checked={this.state.mealType === enumMealType.lunch} />
                                                        <label htmlFor={'ceprb' + enumMealType.lunch}>{enumMealType.lunch}</label>
                                                    </div> : null
                                            }
                                            {
                                                (getAccessLevelByModule(modEnum.BMCU) || getAccessLevelByModule(modEnum.BMCI)) ?
                                                    <div className="styled-input-single col-md-5">
                                                        <input type="radio" name="mealType" id={'ceprb' + enumMealType.breakfast} onChange={() => {
                                                            this.setState({ mealType: enumMealType.breakfast })
                                                        }} checked={this.state.mealType === enumMealType.breakfast} />
                                                        <label htmlFor={'ceprb' + enumMealType.breakfast}>{enumMealType.breakfast}</label>
                                                    </div> : null
                                            }
                                            {
                                                (getAccessLevelByModule(modEnum.SMCU) || getAccessLevelByModule(modEnum.SMCI)) ?
                                                    <div className="styled-input-single col-md-5">
                                                        <input type="radio" name="mealType" id={'ceprb' + enumMealType.snack} onChange={() => {
                                                            this.setState({ mealType: enumMealType.snack })
                                                        }} checked={this.state.mealType === enumMealType.snack} />
                                                        <label htmlFor={'ceprb' + enumMealType.snack}>{enumMealType.snack}</label>
                                                    </div> : null
                                            }

                                            <div className="styled-input-single col-md-3">
                                                <input type="radio" name="mealType" id={'ceprb' + enumMealType.milk} onChange={() => {
                                                    this.setState({ mealType: enumMealType.milk })
                                                }} checked={this.state.mealType === enumMealType.milk} />
                                                <label htmlFor={'ceprb' + enumMealType.milk}>{enumMealType.milk}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                    <div className="styled-input-single col-md-12" style={{ margin: '-45px 15px' }}>
                                        <input type="radio" name="ceprdRpt" id="ceprdSummaryRpt" onChange={() => {
                                            this.setState({ rptType: 0 })
                                        }} checked={this.state.rptType === 0} />
                                        <label htmlFor='ceprdSummaryRpt'>{'Summarized reimbursement claim report'}</label>
                                    </div>
                                    <div className="styled-input-single col-md-12" style={{ margin: '-11px 15px' }}>
                                        <input type="radio" name="ceprdRpt" id="ceprdDailyEditRpt" onChange={() => {
                                            this.setState({ rptType: 1 })
                                        }} checked={this.state.rptType === 1} />
                                        <label htmlFor='ceprdDailyEditRpt'>{'Daily edit check worksheet report'}</label>
                                    </div>
                                </div>
                                {
                                    this.state.rptType === 0 ?
                                        <div>
                                            <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>Select Month</label>
                                                <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                    <Datetime ref='claimCalendar' dateFormat="MMM-YYYY" timeFormat={false}
                                                        closeOnSelect={true} value={moment(this.state.claimMonth)}
                                                        onChange={(e) => {
                                                            const m = moment(e);
                                                            this.setState({
                                                                claimMonth: m,
                                                                startDate: m.clone().startOf('month'),
                                                                endDate: m.clone().endOf('month')
                                                            })
                                                            this.refs.claimCalendar.closeCalendar()
                                                        }} renderInput={this.renderInput} />
                                                </div>
                                            </div>
                                            <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>Start Date</label>
                                                <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                    <Datetime ref='startCalendar' dateFormat={date_format()} timeFormat={false}
                                                        closeOnSelect={true} value={this.state.startDate}
                                                        viewDate={moment(this.state.claimMonth)}
                                                        isValidDate={(current) =>
                                                            current.isSameOrAfter(moment(this.state.claimMonth).startOf('month'), 'day') &&
                                                            current.isSameOrBefore(moment(this.state.claimMonth).endOf('month'), 'day')}
                                                        onChange={(e) => {
                                                            this.setState({ startDate: moment(e) })
                                                            this.refs.startCalendar.closeCalendar()
                                                        }} renderInput={this.renderInput} />
                                                </div>
                                            </div>
                                            <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>End Date</label>
                                                <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                    <Datetime ref='endCalendar' dateFormat={date_format()} timeFormat={false}
                                                        closeOnSelect={true} value={this.state.endDate}
                                                        viewDate={moment(this.state.claimMonth)}
                                                        isValidDate={(current) =>
                                                            current.isSameOrAfter(moment(this.state.claimMonth).startOf('month'), 'day') &&
                                                            current.isSameOrBefore(moment(this.state.claimMonth).endOf('month'), 'day')}
                                                        onChange={(e) => {
                                                            this.setState({ endDate: moment(e) })
                                                            this.refs.endCalendar.closeCalendar()
                                                        }} renderInput={this.renderInput} />
                                                </div>
                                            </div>
                                        </div> :
                                        <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                            <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>Select Month</label>
                                            <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                <Datetime ref='calendar' dateFormat="MMM-YYYY" timeFormat={false}
                                                    closeOnSelect={true} value={moment(this.state.rptMonth)}
                                                    onChange={(e) => {
                                                        this.setState({ rptMonth: moment(e) })
                                                        this.refs.calendar.closeCalendar()
                                                    }} renderInput={this.renderInput} />
                                            </div>
                                        </div>
                                }

                                <div className="row">
                                    <div className="col-md-12">
                                        <button className="btn btn-success btn-sm pull-right" onClick={(e) => {
                                            e.preventDefault();
                                            this.downloadReport();
                                        }}> Download Report
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default CepAuditReport


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/auditReportComponents/cepAuditReport.jsx